import { render, staticRenderFns } from "./ColorTemperatureScale.vue?vue&type=template&id=76a0bb68"
import script from "./ColorTemperatureScale.vue?vue&type=script&lang=js"
export * from "./ColorTemperatureScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorTemperatureSwatch: require('/app/components/ColorTemperatureSwatch.vue').default})
